import { Switch } from 'antd'
import React from 'react'
import { isAVariableBox } from '../../utils/boxes'
import { useStore } from '../../store/store'
import { useOverlay } from '../../contexts/OverlayContext'
import './VariableSwitcher.css'

const VariableSwitcher = ({ boxId, variant = 'dark' }) => {
  const box = useStore(({ boxes, }) => boxes.find((b) => b.id === boxId))
  const isTemplate = useStore(({ currentDocument }) => currentDocument.type === 'template')
  const boxVariableSwitcher = useStore(({ boxVariableSwitcher }) => boxVariableSwitcher)
  const boxVariableSelectedId = useStore((state) => state.boxVariableSelectedId)
  const { overlayProps } = useOverlay();
  const shownStatus = overlayProps.left.shownStatus

  if (!isTemplate || !box) return null

  const isPanel = variant === 'panel'

  return (
    <div data-outside-ignore="true" style={{
      display: 'flex',
      marginRight: isPanel ? 0 : 4,
      width: isPanel ? '100%' : undefined,
      justifyContent: isPanel ? 'space-between' : undefined,
      alignItems: 'center',
      color: isPanel ? 'inherit' : 'white',
      gap: '8px'
    }}>
      <div style={{
        display: 'flex',
        flexDirection: isPanel ? 'row' : 'column',
        lineHeight: '1.2'
      }}>
        {isPanel
          ? <span>Valeurs conditionnelles</span>
          : <><span style={{ textAlign: 'end' }}>Valeurs</span>
            <span style={{ textAlign: 'end' }}>conditionnelles</span></>}
      </div>
      <Switch
        className="custom-switch"
        style={{ width: '44px' }}
        onMouseDown={(e) => e.preventDefault()}
        disabled={(shownStatus === "variables" && boxVariableSelectedId) || (isAVariableBox(box.type) && !box.hideInForm)}
        checked={isAVariableBox(box.type)}
        checkedChildren={<i className="fa-solid fa-check" style={{ color: 'white', fontSize: '12px', position: 'relative', top: '1px', left: '-1px' }} />}
        unCheckedChildren={<i className="fa-solid fa-xmark" style={{ color: 'white', fontSize: '13px', position: 'relative', top: '1px', left: '-1px' }} />}
        onChange={() =>
          boxVariableSwitcher(box.id)
        }
      />
    </div>
  )
}

export default VariableSwitcher
